import { currentRealm } from '@/services/realm';
import { restoreReturnTo } from '@/services/reauth';

// Side-effecting module, imported FIRST in main.tsx — deliberately, and the ordering is the
// whole reason this file exists rather than a call in main.tsx's body.
//
// createBrowserRouter() runs at *import evaluation* of ./router, capturing window.location as
// it goes. ES modules evaluate every import before the importing module's own body, so a call
// placed in main.tsx would run after the router had already read the URL — the replaceState
// would land, and the router would still have booted on /app/ and resolved
// <Navigate to="/app/cabinet" replace/>. Observed exactly that in the browser: the stash was
// consumed, the path was rewritten, and the user still ended up on the cabinet root.
//
// Importing this above './router' makes the restore happen before the router is constructed.
restoreReturnTo();

// A developer's ?realm=admin is read once, as the app boots, so the tab keeps it after the page that
// carried it — the sign-in round trip and every later redirect to the login lose the query.
currentRealm();
